import * as React from "react";
import classnames from "classnames";
import { Icon } from "@grandvisionhq/icons";
/* empty css         */
const icons = {
  astigmatism: "astigmatism",
  bestSeller: "shopping-basket-star",
  blueLightFilter: "blue-light-filter",
  sustainable: "sustainable",
  forBaby: "for-baby",
  forBaby01: "for-baby",
  forBaby03: "for-baby",
  forBaby13: "for-baby",
  forDryEyes: "for-dry-eyes",
  forKids: "for-kids",
  forKids35: "for-kids",
  forKids36: "for-kids",
  forKids46: "for-kids",
  forKids69: "for-kids",
  forKids710: "for-kids",
  forKids1113: "for-kids",
  forKids1114: "for-kids",
  includingGlasses: "frame",
  lastChance: "last-chance",
  mirroredGlasses: "glasses-futuristic",
  multifocal: "store-eye-test",
  newCollection: "new-collection",
  onlineOnly: "happy-computer",
  polarisedGlasses: "polarised-glasses",
  prescription: "store-eye-test",
  seenOnTv: "seen-on-tv",
  staffPick: "shop-assistant",
  storeOnly: "store",
  threeDPrinted: "three-d-printed",
  trendy: "trendy",
  twoMonthsForFree: "shipment-next",
  uvProtection: "polarised-glasses",
  smartGlasses: "smart-glasses",
  hearingGlasses: "nuance-audio"
};
const Tag = ({ className, iconKey, label }) => {
  const iconName = iconKey ? icons[iconKey] : null;
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames(
        "block-tag",
        {
          "block-tag--with-icon": !!iconName
        },
        className
      )
    },
    iconName && /* @__PURE__ */ React.createElement("div", { className: "block-tag__icon" }, /* @__PURE__ */ React.createElement(Icon, { name: iconName, height: 14, width: 14 })),
    /* @__PURE__ */ React.createElement("div", { className: "block-tag__label" }, label)
  );
};
export {
  Tag as default
};
//# sourceMappingURL=Tag.js.map
